export const hexToRgb = (hex: string) => {
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	return result
		? {
				r: parseInt(result[1], 16),
				g: parseInt(result[2], 16),
				b: parseInt(result[3], 16),
		  }
		: null;
};

export const rgbToHex = (rgb: { r: number; g: number; b: number }) =>
	`#${rgb.r.toString(16).padStart(2, '0')}${rgb.g.toString(16).padStart(2, '0')}${rgb.b
		.toString(16)
		.padStart(2, '0')}`;

export const lighten = (rgb: { r: number; g: number; b: number }, factor: number) => ({
	r: Math.min(255, Math.round(rgb.r + (255 - rgb.r) * factor)),
	g: Math.min(255, Math.round(rgb.g + (255 - rgb.g) * factor)),
	b: Math.min(255, Math.round(rgb.b + (255 - rgb.b) * factor)),
});

export const darken = (rgb: { r: number; g: number; b: number }, factor: number) => ({
	r: Math.max(0, Math.round(rgb.r * (1 - factor))),
	g: Math.max(0, Math.round(rgb.g * (1 - factor))),
	b: Math.max(0, Math.round(rgb.b * (1 - factor))),
});

export const mix = (
	color1: { r: number; g: number; b: number },
	color2: { r: number; g: number; b: number },
	ratio: number
) => ({
	r: Math.round(color1.r * (1 - ratio) + color2.r * ratio),
	g: Math.round(color1.g * (1 - ratio) + color2.g * ratio),
	b: Math.round(color1.b * (1 - ratio) + color2.b * ratio),
});

export const isLightColor = (hex: string) => {
	const rgb = hexToRgb(hex);
	if (!rgb) return false;
	const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
	return luminance > 0.5;
};

export const isDarkColor = (hex: string) => {
	const rgb = hexToRgb(hex);
	if (!rgb) return false;
	const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
	return luminance <= 0.5;
};
